import { render, staticRenderFns } from "./shopcategory.vue?vue&type=template&id=74ea9fc9&scoped=true&"
import script from "./shopcategory.vue?vue&type=script&lang=js&"
export * from "./shopcategory.vue?vue&type=script&lang=js&"
import style0 from "./shopcategory.vue?vue&type=style&index=0&id=74ea9fc9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ea9fc9",
  null
  
)

export default component.exports